import useCmsQuery from './useCmsQuery.tsx';
import { getTermsAndConditions, TTermsAndConditionsEntry } from '../../cms';
import useMarketInfo from '../../hooks/useMarketInfo.tsx';

export type { TTermsAndConditionsEntry };

const useTermsAndConditions = (names: string[]): {
  getByName: (name: string) => TTermsAndConditionsEntry | undefined;
  loading: boolean;
  error?: Error;
} => {
  const { flowName, language } = useMarketInfo();
  const namesKey = [...new Set(names.filter(Boolean))].sort().join(',');

  const { data, loading, error } = useCmsQuery(
    () => getTermsAndConditions({ flowName, language, names: namesKey ? namesKey.split(',') : [] }),
    [flowName, language, namesKey],
  );

  return {
    getByName: (name: string) => data?.[name],
    loading,
    error,
  };
};

export default useTermsAndConditions;
